// ========================================================
// Plantillas de correo (diseño «U»): las plantillas de las campañas a contactos como tarjetas,
// el editor (visual o HTML) en el centro y, a la derecha, cómo le llega a un contacto de ejemplo
// en un marco aislado y quién la recibe. Los correos automáticos están en Ajustes › Correo.
// ========================================================

const EmailTemplatesView = {
    editorMode: 'wysiwyg', // 'wysiwyg' or 'html'
    dirty: false,
    TEMPLATES: [
        { type: 'puertas_abiertas', name: 'Puertas abiertas', kind: 'Campaña', when: 'Contactos › Enviar correo › Puertas abiertas',
          who: 'Los contactos marcados en la lista o, si no marcas ninguno, todos los que aceptan newsletter.' },
        { type: 'ultimas_plazas', name: 'Últimas plazas', kind: 'Campaña', when: 'Contactos › Enviar correo › Últimas plazas',
          who: 'Los contactos marcados o, si no marcas ninguno, todos los que aceptan newsletter.' },
        { type: 'admissions', name: 'Correo general', kind: 'Campaña', when: 'Contactos › Enviar correo › Correo general, o «Escribirle un correo» en un contacto',
          who: 'Los que aceptan newsletter entre dos fechas, los marcados, o un solo contacto.' },
        { type: 'invitacion_visita', name: 'Invitación a visitar', kind: 'Un solo correo', when: 'Un contacto que pidió visitar › Invitar',
          who: 'Solo a quien pidió visitar la escuela en el formulario, una única vez, aunque no acepte newsletter.' }
    ],
    VARIABLES: [['{{nombrePila}}', 'Su nombre'], ['{{nombre}}', 'Nombre y apellidos'], ['{{interes}}', 'Lo que le interesa']],

    render() {
        const tool = (icon, title, fn, args = []) => `<button type="button" class="emt-tool" title="${title}" aria-label="${title}" ${UIEvents.attr("click", fn, args)}><i class="fas fa-${icon}" aria-hidden="true"></i></button>`;
        const cmd = function(event,captured){EmailTemplatesView.execCmd(String(captured[0]));};
        return `
            <div class="view-container dnr-proposal emt-view">
                <input type="hidden" id="crm-template-select" value="${this.TEMPLATES[0].type}">
                <div class="emt-head">
                    <div class="emt-head-left">
                        <span class="emt-eyebrow">Alumnado y CRM · Correos a contactos</span>
                        <h1 class="emt-title">Plantillas de correo</h1>
                    </div>
                    <div class="emt-head-actions">
                        <span class="emt-dirty" id="emt-dirty" aria-live="polite">Todo guardado</span>
                        <button type="button" class="emt-btn" ${UIEvents.attr("click", function(event,captured){EmailHtml.previewEditor('crm-template-wysiwyg','crm-template-html-code',EmailTemplatesView.editorMode);}, [])}><i class="fas fa-expand" aria-hidden="true"></i>Ver en grande</button>
                        <button type="button" class="emt-btn is-primary" ${UIEvents.attr("click", function(event,captured){EmailTemplatesView.saveTemplate();}, [])}><i class="fas fa-check" aria-hidden="true"></i>Guardar plantilla</button>
                    </div>
                </div>

                <div class="emt-layout">
                    <nav class="emt-list" aria-label="Plantillas">
                        ${this.TEMPLATES.map((t, i) => `
                            <button type="button" class="emt-pick ${i === 0 ? 'is-on' : ''}" data-type="${t.type}" aria-pressed="${i === 0}" ${UIEvents.attr("click", function(event,captured){EmailTemplatesView.pickTemplate(String(captured[0]));}, [t.type])}>
                                <span class="emt-pick-top"><strong>${t.name}</strong><span class="emt-kind ${t.kind === 'Campaña' ? '' : 'is-one'}">${t.kind}</span></span>
                                <span class="emt-pick-when">${t.when}</span>
                                <span class="emt-pick-subject" id="emt-subject-${t.type}">…</span>
                            </button>`).join('')}
                        <p class="emt-note">Los correos automáticos de la app (acceso, entrevista, pago…) están en Ajustes › Correo.</p>
                    </nav>

                    <section class="emt-card emt-editor" aria-labelledby="emt-editor-title">
                        <div class="emt-editor-head">
                            <h2 class="emt-h2" id="emt-editor-title">${this.TEMPLATES[0].name}</h2>
                            <label class="emt-field">Asunto
                                <input type="text" id="crm-template-subject" class="emt-input" placeholder="Asunto del correo" ${UIEvents.attr("input", function(event,captured){EmailTemplatesView.changed();}, [])}>
                            </label>
                        </div>
                        <div class="emt-toolbar">
                            <div class="emt-mode" role="group" aria-label="Modo del editor">
                                <button type="button" id="crm-mode-btn-wysiwyg" class="is-on" aria-pressed="true" ${UIEvents.attr("click", function(event,captured){EmailTemplatesView.setEditorMode('wysiwyg');}, [])}>Visual</button>
                                <button type="button" id="crm-mode-btn-html" aria-pressed="false" ${UIEvents.attr("click", function(event,captured){EmailTemplatesView.setEditorMode('html');}, [])}>HTML</button>
                            </div>
                            <span class="emt-tools" id="crm-wysiwyg-tools">
                                ${tool('rotate-left', 'Deshacer', cmd, ['undo'])}${tool('rotate-right', 'Rehacer', cmd, ['redo'])}
                                <span class="emt-sep" aria-hidden="true"></span>
                                ${tool('bold', 'Negrita', cmd, ['bold'])}${tool('italic', 'Cursiva', cmd, ['italic'])}${tool('underline', 'Subrayado', cmd, ['underline'])}${tool('strikethrough', 'Tachado', cmd, ['strikeThrough'])}
                                <select class="emt-heading" title="Estilo de párrafo" aria-label="Estilo de párrafo" ${UIEvents.attr("change", function(event,captured){EmailTemplatesView.execCmd('formatBlock',this.value);this.value='';}, [])}>
                                    <option value="" selected disabled>Estilo…</option>
                                    <option value="p">Párrafo</option>
                                    <option value="h2">Título 2</option>
                                    <option value="h3">Título 3</option>
                                </select>
                                <input type="color" class="emt-color" title="Color de texto" aria-label="Color de texto" value="#0f172a" ${UIEvents.attr("change", function(event,captured){EmailTemplatesView.execCmd('foreColor',this.value);}, [])}>
                                <span class="emt-sep" aria-hidden="true"></span>
                                ${tool('list-ul', 'Lista con viñetas', cmd, ['insertUnorderedList'])}${tool('list-ol', 'Lista numerada', cmd, ['insertOrderedList'])}
                                ${tool('align-left', 'Alinear a la izquierda', cmd, ['justifyLeft'])}${tool('align-center', 'Centrar', cmd, ['justifyCenter'])}${tool('align-right', 'Alinear a la derecha', cmd, ['justifyRight'])}
                                <span class="emt-sep" aria-hidden="true"></span>
                                ${tool('link', 'Insertar enlace', function(event,captured){EmailTemplatesView.insertLink();})}${tool('image', 'Insertar imagen', function(event,captured){EmailTemplatesView.insertImage();})}${tool('eraser', 'Quitar formato', cmd, ['removeFormat'])}
                            </span>
                        </div>
                        <div class="emt-vars">
                            <span>Insertar:</span>
                            ${this.VARIABLES.map(([tag, label]) => `<button type="button" class="emt-var" ${UIEvents.attr("click", function(event,captured){EmailTemplatesView.insertTag(String(captured[0]));}, [tag])}><code>${tag}</code>${label}</button>`).join('')}
                        </div>
                        <div id="crm-wysiwyg-container" class="emt-wysiwyg-container">
                            <div id="crm-template-wysiwyg" class="emt-wysiwyg-editor" contenteditable="true" ${UIEvents.attr("input", function(event,captured){EmailTemplatesView.changed();}, [])}></div>
                        </div>
                        <textarea id="crm-template-html-code" class="emt-html-editor" aria-label="Código HTML del correo" placeholder="Escribe el cuerpo del correo en HTML o texto plano..." style="display: none;" ${UIEvents.attr("input", function(event,captured){EmailTemplatesView.changed();}, [])}></textarea>
                    </section>

                    <aside class="emt-side">
                        <section class="emt-card emt-preview-card" aria-labelledby="emt-preview-title">
                            <div class="emt-card-head"><h2 class="emt-h2 is-small" id="emt-preview-title">Así lo recibe</h2><span class="emt-note">Con datos de ejemplo</span></div>
                            <div class="emt-mail">
                                <div class="emt-mail-head"><span>Para: ${Utils.sanitizeHTML(this.sample().email)}</span><strong id="emt-preview-subject"></strong></div>
                                <div class="emt-mail-body" id="emt-preview"></div>
                            </div>
                        </section>
                        <section class="emt-card emt-who" aria-labelledby="emt-who-title">
                            <strong id="emt-who-title">Quién la recibe</strong>
                            <span id="emt-who">${this.TEMPLATES[0].who}</span>
                            <span class="emt-note">Nunca a quien ya es alumno o está matriculado.</span>
                            <button type="button" class="emt-link" ${UIEvents.attr("click", function(event,captured){App.navigate('leads');}, [])}>Ir a Contactos para enviarla ›</button>
                        </section>
                    </aside>
                </div>
            </div>
        `;
    },

    // Sample contact for the preview: the first study plan of the school, never a fixed name.
    sample() {
        const plan = typeof StudyPlanService !== 'undefined' ? StudyPlanService.plans?.find(p => p.active !== false)?.name : '';
        return { nombre: 'Irati Goñi Zabala', nombrePila: 'Irati', interes: plan || 'la formación que eligió', email: 'irati@ejemplo.com' };
    },

    attachEventListeners() {
        // The template cards already have their click handlers in the markup.
    },

    init() {
        this.editorMode = 'wysiwyg';
        this.dirty = false;
        const select = document.getElementById('crm-template-select');
        if (select) this.loadTemplate(select.value);
        this.loadSubjects();
    },

    // Subject of every saved template for the cards (a template never saved uses the default text).
    async loadSubjects() {
        const token = AuthManager.getCsrfToken();
        await Promise.all(this.TEMPLATES.map(async t => {
            let text = 'Usa el texto por defecto';
            try {
                const res = await fetch(`/api/settings/email-templates/${t.type}`, { headers: { 'X-SICAF-CSRF': token } }).then(r => r.ok ? r.json() : null);
                if (res?.template?.subject) text = `«${res.template.subject}»`;
            } catch { /* the card keeps the default text */ }
            const node = document.getElementById('emt-subject-' + t.type);
            if (node) node.textContent = text;
        }));
    },

    async pickTemplate(type) {
        const select = document.getElementById('crm-template-select');
        if (!select || select.value === type) return;
        if (this.dirty) {
            const answer = await SafeHTML.fire({ title: 'Cambios sin guardar', text: 'Si cambias de plantilla se perderán los cambios de esta.', icon: 'warning', showCancelButton: true, confirmButtonText: 'Cambiar sin guardar', cancelButtonText: 'Seguir editando' });
            if (!answer.isConfirmed) return;
        }
        select.value = type;
        const t = this.TEMPLATES.find(x => x.type === type);
        document.querySelectorAll('.emt-pick').forEach(b => { const on = b.dataset.type === type; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
        const title = document.getElementById('emt-editor-title'); if (title) title.textContent = t.name;
        const who = document.getElementById('emt-who'); if (who) who.textContent = t.who;
        this.loadTemplate(type);
    },

    setDirty(value) {
        this.dirty = value;
        const note = document.getElementById('emt-dirty');
        if (note) { note.textContent = value ? 'Cambios sin guardar' : 'Todo guardado'; note.classList.toggle('is-dirty', value); }
    },

    changed() {
        this.setDirty(true);
        clearTimeout(this._previewTimer);
        this._previewTimer = setTimeout(() => this.updatePreview(), 300);
    },

    // The preview always goes through the same cleaning as the saved template, inside a sandboxed frame.
    updatePreview() {
        const box = document.getElementById('emt-preview');
        if (!box) return;
        const s = this.sample();
        const fill = text => String(text || '').replace(/\{\{(nombrePila|nombre|interes)\}\}/g, (_, key) => s[key]);
        const subject = document.getElementById('emt-preview-subject');
        if (subject) subject.textContent = fill(document.getElementById('crm-template-subject')?.value);
        const html = this.editorMode === 'html' ? document.getElementById('crm-template-html-code')?.value : document.getElementById('crm-template-wysiwyg')?.innerHTML;
        try {
            const safeSample = { nombre: Utils.sanitizeHTML(s.nombre), nombrePila: Utils.sanitizeHTML(s.nombrePila), interes: Utils.sanitizeHTML(s.interes) };
            box.replaceChildren(EmailHtml.frame(String(html || '').replace(/\{\{(nombrePila|nombre|interes)\}\}/g, (_, key) => safeSample[key]), 'Vista previa del correo con datos de ejemplo'));
        } catch (error) {
            const p = document.createElement('p'); p.className = 'emt-note'; p.textContent = error.message; box.replaceChildren(p);
        }
    },

    markMode(mode) {
        const on = mode === 'wysiwyg';
        const visual = document.getElementById('crm-mode-btn-wysiwyg'), code = document.getElementById('crm-mode-btn-html');
        visual?.classList.toggle('is-on', on); visual?.setAttribute('aria-pressed', String(on));
        code?.classList.toggle('is-on', !on); code?.setAttribute('aria-pressed', String(!on));
        const tools = document.getElementById('crm-wysiwyg-tools'); if (tools) tools.hidden = !on;
    },

    setEditorMode(mode) {
        if (this.editorMode === mode) return;

        const wysiwygContainer = document.getElementById('crm-wysiwyg-container');
        const wysiwygEditor = document.getElementById('crm-template-wysiwyg');
        const htmlEditor = document.getElementById('crm-template-html-code');

        if (mode === 'wysiwyg') {
            // Sync Code HTML -> Visual
            try { EmailHtml.set(wysiwygEditor, htmlEditor.value, htmlEditor); }
            catch (error) { Utils.showToast(error.message, 'error'); return; }
            wysiwygContainer.style.display = 'block';
            htmlEditor.style.display = 'none';
        } else {
            // Sync Visual -> Code HTML
            htmlEditor.value = wysiwygEditor.innerHTML;
            wysiwygContainer.style.display = 'none';
            htmlEditor.style.display = 'block';
        }
        this.editorMode = mode;
        this.markMode(mode);
    },

    execCmd(command, value = null) {
        document.execCommand(command, false, value);
        const wysiwygEditor = document.getElementById('crm-template-wysiwyg');
        const htmlEditor = document.getElementById('crm-template-html-code');
        if (wysiwygEditor && htmlEditor) {
            htmlEditor.value = wysiwygEditor.innerHTML;
        }
        this.changed();
    },

    insertTag(tag) {
        const wysiwygEditor = document.getElementById('crm-template-wysiwyg');
        if (!wysiwygEditor) return;
        if (this.editorMode === 'html') {
            const code = document.getElementById('crm-template-html-code');
            const at = code.selectionStart ?? code.value.length, end = code.selectionEnd ?? at;
            code.value = code.value.slice(0, at) + tag + code.value.slice(end);
            code.focus(); code.selectionStart = code.selectionEnd = at + tag.length;
            this.changed();
            return;
        }
        wysiwygEditor.focus();
        
        // Use Selection APIs or basic append
        const selection = window.getSelection();
        if (selection.getRangeAt && selection.rangeCount && wysiwygEditor.contains(selection.anchorNode)) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            range.insertNode(document.createTextNode(tag));
        } else {
            wysiwygEditor.appendChild(document.createTextNode(tag));
        }

        const htmlEditor = document.getElementById('crm-template-html-code');
        if (htmlEditor) {
            htmlEditor.value = wysiwygEditor.innerHTML;
        }
        this.changed();
    },

    insertLink() {
        const wysiwygEditor = document.getElementById('crm-template-wysiwyg');
        if (!wysiwygEditor) return;
        wysiwygEditor.focus();

        const selection = window.getSelection();
        const selectedText = selection.toString();

        let defaultUrl = 'https://';
        // If clicking/selecting an existing anchor element
        let anchorNode = null;
        if (selection.rangeCount > 0) {
            let node = selection.anchorNode;
            while (node && node !== wysiwygEditor) {
                if (node.nodeName === 'A') {
                    anchorNode = node;
                    defaultUrl = node.getAttribute('href');
                    break;
                }
                node = node.parentNode;
            }
        }

        // SweetAlert2 styled link prompt
        if (typeof Swal !== 'undefined') {
            SafeHTML.fire({
                title: 'Insertar / Editar Enlace',
                input: 'url',
                inputLabel: 'Dirección URL del Enlace',
                inputValue: defaultUrl,
                placeholder: 'https://ejemplo.com',
                showCancelButton: true,
                confirmButtonColor: 'var(--primary-color)',
                confirmButtonText: 'Aplicar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Debes introducir una URL válida';
                    }
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = result.value;
                    if (!EmailHtml.validLink(url)) return;
                    if (anchorNode) {
                        anchorNode.setAttribute('href', url);
                    } else {
                        document.execCommand('createLink', false, url);
                    }
                    // Sync updates
                    const htmlEditor = document.getElementById('crm-template-html-code');
                    if (htmlEditor) {
                        htmlEditor.value = wysiwygEditor.innerHTML;
                    }
                }
            });
        } else {
            const url = prompt('Introduce la dirección URL:', defaultUrl);
            if (url && EmailHtml.validLink(url)) {
                if (anchorNode) {
                    anchorNode.setAttribute('href', url);
                } else {
                    document.execCommand('createLink', false, url);
                }
                const htmlEditor = document.getElementById('crm-template-html-code');
                if (htmlEditor) {
                    htmlEditor.value = wysiwygEditor.innerHTML;
                }
            }
        }
    },

    insertImage() {
        const wysiwygEditor = document.getElementById('crm-template-wysiwyg');
        if (!wysiwygEditor) return;
        wysiwygEditor.focus();

        const applyImage = (url) => {
            if (!url || !EmailHtml.validLink(url, true)) return;
            document.execCommand('insertHTML', false, EmailHtml.clean(`<img src="${Utils.sanitizeHTML(url)}" alt="" style="max-width:100%; height:auto; display:block;">`));
            const htmlEditor = document.getElementById('crm-template-html-code');
            if (htmlEditor) htmlEditor.value = wysiwygEditor.innerHTML;
        };

        if (typeof Swal !== 'undefined') {
            SafeHTML.fire({
                title: 'Insertar Imagen',
                input: 'url',
                inputLabel: 'Dirección URL de la Imagen',
                placeholder: 'https://ejemplo.com/logo.png',
                showCancelButton: true,
                confirmButtonColor: 'var(--primary-color)',
                confirmButtonText: 'Insertar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value) {
                        return 'Debes introducir una URL válida';
                    }
                }
            }).then((result) => {
                if (result.isConfirmed) applyImage(result.value);
            });
        } else {
            applyImage(prompt('Introduce la URL de la imagen:', 'https://'));
        }
    },

    async loadTemplate(type) {
        const request = this._loadRequest = (this._loadRequest || 0) + 1;
        this._loadedType = null;
        const subjectInput = document.getElementById('crm-template-subject');
        const wysiwygEditor = document.getElementById('crm-template-wysiwyg');
        const htmlEditor = document.getElementById('crm-template-html-code');
        
        if (!subjectInput || !wysiwygEditor || !htmlEditor) return;

        subjectInput.disabled = true;
        wysiwygEditor.contentEditable = false;
        htmlEditor.disabled = true;
        
        subjectInput.value = 'Cargando...';
        SafeHTML.set(wysiwygEditor, '<p style="color:#64748b; font-style:italic;">Cargando plantilla visual...</p>');
        htmlEditor.value = 'Cargando contenido HTML de la plantilla desde el servidor...';

        try {
            const token = AuthManager.getCsrfToken();
            const response = await fetch(`/api/settings/email-templates/${type}`, {
                headers: { 'X-SICAF-CSRF': token }
            });
            const res = await response.json();
            if (request !== this._loadRequest || !subjectInput.isConnected) return;
            if (!response.ok || !res.success) throw new Error('No se pudo cargar la plantilla');

            let targetSubject = '';
            let targetBody = '';

            if (res.success && res.template) {
                targetSubject = res.template.subject || '';
                targetBody = res.template.body || '';
            } else {
                if (type === 'invitacion_visita') {
                    ({ subject: targetSubject, body: targetBody } = LeadsView.visitInvitationDefault());
                } else if (type === 'puertas_abiertas') {
                    targetSubject = `Invitación: Jornada de Puertas Abiertas en ${SchoolService.shortName()}`;
                    targetBody = `<div style="background-color: #f8fafc; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding: 30px 20px; color: #334155; line-height: 1.6; font-size: 16px; width: 100%; max-width: 600px; margin: 0 auto; border-radius: 12px; box-sizing: border-box;">
    <!-- Header Logo -->
    <div style="text-align: center; margin-bottom: 25px; border-bottom: 2px solid #e2e8f0; padding-bottom: 15px;">
        <span style="font-size: 22px; font-weight: 800; color: #0c4a60; letter-spacing: 0.05em; text-transform: uppercase;">${Utils.sanitizeHTML(SchoolService.shortName())}</span>
        <div style="font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase; margin-top: 3px; letter-spacing: 0.08em;">${Utils.sanitizeHTML(SchoolService.name())}</div>
    </div>
    
    <!-- Card Body -->
    <div style="background-color: #ffffff; padding: 25px; border-radius: 8px; border: 1px solid #e2e8f0;">
        <p style="margin-top: 0; font-size: 17px; font-weight: 700; color: #0c4a60;">Hola, {{nombre}}:</p>
        
        <p style="margin-bottom: 15px;">Nos complace invitarte a nuestra próxima <strong>Jornada de Puertas Abiertas</strong> en ${Utils.sanitizeHTML(SchoolService.name())}.</p>
        
        <!-- Callout Box -->
        <div style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border-left: 4px solid #d97706; padding: 18px; border-radius: 0 6px 6px 0; margin: 20px 0; text-align: left;">
            <div style="font-size: 12px; font-weight: 700; color: #b45309; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 5px;">Formación de interés</div>
            <div style="font-size: 18px; font-weight: 800; color: #78350f; line-height: 1.3;">{{interes}}</div>
            <p style="margin: 8px 0 0 0; font-size: 14px; color: #92400e;">Es la ocasión perfecta para que puedas visitar nuestras instalaciones, ver los platós de rodaje y aulas tecnológicas, y conversar de tú a tú con coordinadores y profesores de tu especialidad.</p>
        </div>

        <p style="margin-bottom: 20px;">Las plazas son limitadas por aforo. Si deseas asistir y venir acompañado, te sugerimos reservar tu acreditación gratuita lo antes posible.</p>
        
        <!-- CTA Button -->
        <div style="text-align: center; margin: 25px 0;">
            <a href="${Utils.sanitizeHTML(SchoolService.get('website') || '#')}" style="background-color: #d97706; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 50px; font-weight: 700; font-size: 14px; display: inline-block; box-shadow: 0 4px 8px rgba(217,119,6,0.2);">Confirmar Asistencia Gratuita</a>
        </div>
        
        <!-- Signature -->
        <div style="border-top: 1px solid #f1f5f9; padding-top: 15px; margin-top: 25px; font-size: 13px; color: #64748b;">
            Te esperamos,<br>
            <strong style="color: #0c4a60; font-weight: 700;">Equipo de Coordinación y Eventos</strong><br>
            <span style="font-size: 11px; color: #94a3b8;">${Utils.sanitizeHTML(SchoolService.name())} | ${Utils.sanitizeHTML(SchoolService.shortName())}</span>
        </div>
    </div>
    
    <!-- Footer -->
    <div style="text-align: center; margin-top: 20px; font-size: 10px; color: #94a3b8; line-height: 1.4;">
        Recibes esta invitación como parte del seguimiento de tu solicitud de información.<br>
        © ${new Date().getFullYear()} ${Utils.sanitizeHTML(SchoolService.name())}. Todos los derechos reservados.
    </div>
</div>`;
                } else if (type === 'ultimas_plazas') {
                    targetSubject = `¡Últimas Plazas Disponibles! - ${SchoolService.shortName()}`;
                    targetBody = `<div style="background-color: #f8fafc; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding: 30px 20px; color: #334155; line-height: 1.6; font-size: 16px; width: 100%; max-width: 600px; margin: 0 auto; border-radius: 12px; box-sizing: border-box;">
    <!-- Header Logo -->
    <div style="text-align: center; margin-bottom: 25px; border-bottom: 2px solid #e2e8f0; padding-bottom: 15px;">
        <span style="font-size: 22px; font-weight: 800; color: #0c4a60; letter-spacing: 0.05em; text-transform: uppercase;">${Utils.sanitizeHTML(SchoolService.shortName())}</span>
        <div style="font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase; margin-top: 3px; letter-spacing: 0.08em;">${Utils.sanitizeHTML(SchoolService.name())}</div>
    </div>
    
    <!-- Card Body -->
    <div style="background-color: #ffffff; padding: 25px; border-radius: 8px; border: 1px solid #e2e8f0;">
        <p style="margin-top: 0; font-size: 17px; font-weight: 700; color: #b91c1c;">Hola, {{nombre}}:</p>
        
        <p style="margin-bottom: 15px;">Te escribimos con carácter preferente para informarte de que el grupo para la formación <strong>{{interes}}</strong> está muy cerca de completarse.</p>
        
        <!-- Callout Box -->
        <div style="background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%); border-left: 4px solid #ef4444; padding: 18px; border-radius: 0 6px 6px 0; margin: 20px 0; text-align: left;">
            <div style="font-size: 12px; font-weight: 700; color: #b91c1c; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 5px;">Convocatoria de Matrícula</div>
            <div style="font-size: 18px; font-weight: 800; color: #7f1d1d; line-height: 1.3;">{{interes}}</div>
            <p style="margin: 8px 0 0 0; font-size: 14px; color: #991b1b;">Con el fin de garantizar una formación práctica y personalizada de máxima calidad en plató, el cupo de alumnos por aula es rigurosamente limitado. Quedan muy pocas plazas libres para el inicio del curso.</p>
        </div>

        <p style="margin-bottom: 20px;">Si estás interesado en asegurar tu plaza para esta convocatoria, te recomendamos formalizar el proceso de matrícula a la mayor brevedad.</p>
        
        <!-- CTA Button -->
        <div style="text-align: center; margin: 25px 0;">
            <a href="${Utils.sanitizeHTML(SchoolService.get('website') || '#')}" style="background-color: #ef4444; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 50px; font-weight: 700; font-size: 14px; display: inline-block; box-shadow: 0 4px 8px rgba(239,68,68,0.2);">Reservar mi Plaza Ahora</a>
        </div>
        
        <!-- Signature -->
        <div style="border-top: 1px solid #f1f5f9; padding-top: 15px; margin-top: 25px; font-size: 13px; color: #64748b;">
            Un saludo cordial,<br>
            <strong style="color: #0c4a60; font-weight: 700;">Departamento de Admisiones y Reservas</strong><br>
            <span style="font-size: 11px; color: #94a3b8;">${Utils.sanitizeHTML(SchoolService.name())} | ${Utils.sanitizeHTML(SchoolService.shortName())}</span>
        </div>
    </div>
    
    <!-- Footer -->
    <div style="text-align: center; margin-top: 20px; font-size: 10px; color: #94a3b8; line-height: 1.4;">
        Recibes esta notificación de prioridad debido a tu solicitud de información previa.<br>
        © ${new Date().getFullYear()} ${Utils.sanitizeHTML(SchoolService.name())}. Todos los derechos reservados.
    </div>
</div>`;
                } else {
                    targetSubject = `¡Matrícula Abierta en ${SchoolService.shortName()}! Curso ${new Date().getMonth() >= 9 ? new Date().getFullYear() + 1 : new Date().getFullYear()}/${(new Date().getMonth() >= 9 ? new Date().getFullYear() + 1 : new Date().getFullYear()) + 1}`;
                    targetBody = `<div style="background-color: #f8fafc; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; padding: 30px 20px; color: #334155; line-height: 1.6; font-size: 16px; width: 100%; max-width: 600px; margin: 0 auto; border-radius: 12px; box-sizing: border-box;">
    <!-- Header Logo -->
    <div style="text-align: center; margin-bottom: 25px; border-bottom: 2px solid #e2e8f0; padding-bottom: 15px;">
        <span style="font-size: 22px; font-weight: 800; color: #0c4a60; letter-spacing: 0.05em; text-transform: uppercase;">${Utils.sanitizeHTML(SchoolService.shortName())}</span>
        <div style="font-size: 11px; color: #64748b; font-weight: 700; text-transform: uppercase; margin-top: 3px; letter-spacing: 0.08em;">${Utils.sanitizeHTML(SchoolService.name())}</div>
    </div>
    
    <!-- Card Body -->
    <div style="background-color: #ffffff; padding: 25px; border-radius: 8px; border: 1px solid #e2e8f0;">
        <p style="margin-top: 0; font-size: 17px; font-weight: 700; color: #0c4a60;">Hola, {{nombre}}:</p>
        
        <p style="margin-bottom: 15px;">Te escribimos desde <strong>${Utils.sanitizeHTML(SchoolService.name())}</strong> para agradecer tu interés en nuestra oferta formativa.</p>
        
        <!-- Callout Box -->
        <div style="background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%); border-left: 4px solid #0b5f59; padding: 18px; border-radius: 0 6px 6px 0; margin: 20px 0; text-align: left;">
            <div style="font-size: 12px; font-weight: 700; color: #0b5f59; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 5px;">Formación de interés</div>
            <div style="font-size: 18px; font-weight: 800; color: #0c4a60; line-height: 1.3;">{{interes}}</div>
            <p style="margin: 8px 0 0 0; font-size: 14px; color: #475569;">Queríamos informarte de que ya se encuentra abierto el plazo de inscripción para el próximo curso académico. Recuerda que las plazas se asignan por orden de matrícula.</p>
        </div>

        <p style="margin-bottom: 20px;">Si deseas concertar una entrevista personalizada, programar una visita a nuestras instalaciones o resolver dudas sobre el plan de estudios, estamos a tu entera disposición.</p>
        
        <!-- CTA Button -->
        <div style="text-align: center; margin: 25px 0;">
            <a href="${Utils.sanitizeHTML(SchoolService.get('website') || '#')}" style="background-color: #0b5f59; color: #ffffff; text-decoration: none; padding: 12px 24px; border-radius: 50px; font-weight: 700; font-size: 14px; display: inline-block; box-shadow: 0 4px 8px rgba(11,95,89,0.2);">Conoce la Escuela y Matricúlate</a>
        </div>
        
        <!-- Signature -->
        <div style="border-top: 1px solid #f1f5f9; padding-top: 15px; margin-top: 25px; font-size: 13px; color: #64748b;">
            Atentamente,<br>
            <strong style="color: #0c4a60; font-weight: 700;">Equipo de Admisiones y Matrícula</strong><br>
            <span style="font-size: 11px; color: #94a3b8;">${Utils.sanitizeHTML(SchoolService.name())} | ${Utils.sanitizeHTML(SchoolService.shortName())}</span>
        </div>
    </div>
    
    <!-- Footer -->
    <div style="text-align: center; margin-top: 20px; font-size: 10px; color: #94a3b8; line-height: 1.4;">
        Recibes esta respuesta a tu consulta web.<br>
        © ${new Date().getFullYear()} ${Utils.sanitizeHTML(SchoolService.name())}. Todos los derechos reservados.
    </div>
</div>`;
                }
            }

            subjectInput.value = targetSubject;
            EmailHtml.set(wysiwygEditor, targetBody, htmlEditor);
            this._loadedType = type;
            if (res.adjusted) Utils.showToast('Plantilla normalizada para mostrarla con seguridad. El original se conserva hasta que guardes.', 'info');

            // Enforce visual mode on load
            this.editorMode = 'wysiwyg';
            document.getElementById('crm-wysiwyg-container').style.display = 'block';
            htmlEditor.style.display = 'none';
            this.markMode('wysiwyg');
            this.setDirty(false);
            this.updatePreview();

        } catch (error) {
            if (request !== this._loadRequest || !subjectInput.isConnected) return;
            console.error('Error loading CRM template:', error);
            Utils.showToast('Error al cargar plantilla desde el servidor', 'error');
            subjectInput.value = '';
            SafeHTML.set(wysiwygEditor, '');
            htmlEditor.value = '';
        } finally {
            if (request === this._loadRequest && subjectInput.isConnected) {
                subjectInput.disabled = false;
                wysiwygEditor.contentEditable = true;
                htmlEditor.disabled = false;
            }
        }
    },

    async saveTemplate() {
        if (!AuthManager.requireModuleManage("email-templates",["admin"])) return;
        const select = document.getElementById('crm-template-select');
        const subjectInput = document.getElementById('crm-template-subject');
        const wysiwygEditor = document.getElementById('crm-template-wysiwyg');
        const htmlEditor = document.getElementById('crm-template-html-code');

        if (!select || !subjectInput || !wysiwygEditor || !htmlEditor) return;

        const templateType = select.value;
        if (this._saving) return;
        if (this._loadedType !== templateType) { Utils.showToast('Espera a que se cargue la plantilla o vuelve a seleccionarla.', 'warning'); return; }
        const subject = subjectInput.value.trim();
        
        // Use active editor to read body value
        const body = (this.editorMode === 'wysiwyg') 
            ? wysiwygEditor.innerHTML 
            : htmlEditor.value.trim();

        if (!subject || !body) {
            Utils.showToast('El asunto y contenido son obligatorios.', 'warning');
            return;
        }

        this._saving = true;
        try {
            const token = AuthManager.getCsrfToken();
            const response = await fetch('/api/settings/email-templates', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-SICAF-CSRF': token
                },
                body: JSON.stringify({ 
                    templateType, 
                    subject, 
                    body 
                })
            });

            const res = await response.json();
            if (response.ok && res.success) {
                if (select.isConnected && select.value === templateType && (this.editorMode === 'wysiwyg' ? wysiwygEditor.innerHTML : htmlEditor.value.trim()) === body) EmailHtml.set(wysiwygEditor, res.template.body, htmlEditor);
                Utils.showToast(res.adjusted ? 'Plantilla guardada. Se ha normalizado el HTML; revisa la vista previa.' : 'Plantilla guardada con éxito', 'success');
                if (select.value === templateType) { this.setDirty(false); this.updatePreview(); }
                const card = document.getElementById('emt-subject-' + templateType);
                if (card) card.textContent = `«${subject}»`;
            } else {
                throw new Error(res.error || 'Fallo de guardado');
            }
        } catch (error) {
            console.error('Error saving CRM template:', error);
            Utils.showToast('Error al conectar con el servidor', 'error');
        } finally {
            this._saving = false;
        }
    }
};

window.EmailTemplatesView = EmailTemplatesView;
